<div class="geo-shell" [class.geo-shell--focus]="isGisFocusMode" [class.geo-shell--boq]="boqWorkbench">
  <header class="geo-shell-header" *ngIf="!isGisFocusMode">
    <div class="geo-shell-brand">
      <h1 class="geo-shell-title">{{ boqWorkbench ? 'GIS Road BoQ' : 'SigmaT Geospatial' }}</h1>
      <p class="geo-shell-subtitle">
        {{ boqWorkbench ? 'Chainage quantities, corridor assets, and cost from the map' : 'GIS editing, LRS chainage &amp; assets, UNM utility network' }}
      </p>
    </div>

    <div class="geo-shell-right">
      <div class="geo-shell-context" *ngIf="projectId || projectName">
        <span class="geo-context-label">Project</span>
        <span class="geo-context-value">{{ projectName || projectId }}</span>
      </div>
      <button type="button" class="geo-lrs-demo-btn" (click)="launchLrsDemo()" *ngIf="!boqWorkbench">
        ▶ One-click LRS demo
      </button>
      <button
        type="button"
        class="geo-focus-btn"
        (click)="enterGisFocusMode()"
        title="Hide app header and sidenav"
      >
        Focus map
      </button>
    </div>
  </header>

  <button
    *ngIf="isGisFocusMode"
    type="button"
    class="geo-focus-exit"
    (click)="exitGisFocusMode()"
    title="Exit focus (Esc)"
    aria-label="Exit focus"
  >
    ×
  </button>

  <div
    class="geo-unified-workspace"
    [class.geo-unified-workspace--dash-expanded]="lrsDashExpanded && !isGisFocusMode"
    [class.geo-unified-workspace--boq]="boqWorkbench && !isGisFocusMode"
    [class.explorer-collapsed]="boqWorkbench && explorerCollapsed"
    [class.params-collapsed]="boqWorkbench && paramsCollapsed"
    [class.table-expanded]="boqWorkbench && tableExpanded"
  >
    <aside
      *ngIf="boqWorkbench && !isGisFocusMode"
      class="geo-boq-pane geo-boq-pane--explorer"
      [class.geo-boq-pane--collapsed]="explorerCollapsed"
    >
      <div class="geo-boq-pane-body" [hidden]="explorerCollapsed" [attr.aria-hidden]="explorerCollapsed">
        <app-gis-boq-explorer class="geo-boq-explorer"></app-gis-boq-explorer>
      </div>
      <button
        type="button"
        class="geo-boq-rail"
        (click)="toggleExplorer()"
        [attr.aria-expanded]="!explorerCollapsed"
        [attr.aria-label]="explorerCollapsed ? 'Show layers' : 'Hide layers'"
        [attr.title]="explorerCollapsed ? 'Show layers' : 'Hide layers'"
      >
        Layers
      </button>
    </aside>

    <div class="geo-boq-map">
      <app-gisavieditor
        [enableLrsTab]="true"
        [compactForBoq]="boqWorkbench"
        class="geo-gis-main"
      ></app-gisavieditor>
    </div>

    <aside
      *ngIf="boqWorkbench && !isGisFocusMode"
      class="geo-boq-pane geo-boq-pane--params"
      [class.geo-boq-pane--collapsed]="paramsCollapsed"
    >
      <button
        type="button"
        class="geo-boq-rail"
        (click)="toggleParams()"
        [attr.aria-expanded]="!paramsCollapsed"
        [attr.aria-label]="paramsCollapsed ? 'Show section' : 'Hide section'"
        [attr.title]="paramsCollapsed ? 'Show section' : 'Hide section'"
      >
        Section
      </button>
      <div class="geo-boq-pane-body" [hidden]="paramsCollapsed" [attr.aria-hidden]="paramsCollapsed">
        <app-gis-boq-params class="geo-boq-params"></app-gis-boq-params>
      </div>
    </aside>

    <div *ngIf="boqWorkbench && !isGisFocusMode" class="geo-boq-table-pane">
      <app-gis-boq-table
        class="geo-boq-table"
        [tableExpanded]="tableExpanded"
        (tableExpandedChange)="onTableExpanded($event)"
      ></app-gis-boq-table>
    </div>

    <app-lrs-dashboard-panel
      *ngIf="!isGisFocusMode && showLrsPanel"
      class="geo-lrs-dash"
      [class.geo-lrs-dash--expanded]="lrsDashExpanded"
      [expanded]="lrsDashExpanded"
      (expandedChange)="onLrsDashExpandedChange($event)"
    ></app-lrs-dashboard-panel>
  </div>
</div>
